export class updateTitleTable {
    start: number;
    end:  number;
    constructor (start,end) {
        this.start = start;
        this.end =  end;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/broadcaster/info-expense/update-title-table.ts